/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.SubscriptionSource_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.SubscriptionSource domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum SubscriptionSource_ {
   /// <summary>
   ///   Partner Initiated Registration via Token (PaToken)
   /// </summary>
   PartnerInitiatedRegistration = 1,
   /// <summary>
   ///   Customer Initiated Registration (Customer)
   /// </summary>
   CustomerInitiatedRegistration = 2
}

export const SubscriptionSources: SubscriptionSource[] = [
   {
      code: SubscriptionSource_.PartnerInitiatedRegistration,
      literal: 'PartnerInitiatedRegistration',
      description: 'Partner Initiated Registration via Token',
      shortDescription: 'PaToken',
      listPriority: 0,

      typeName: "SubscriptionSource"
   },
   {
      code: SubscriptionSource_.CustomerInitiatedRegistration,
      literal: 'CustomerInitiatedRegistration',
      description: 'Customer Initiated Registration',
      shortDescription: 'Customer',
      listPriority: 0,

      typeName: "SubscriptionSource"
   }
]

export class SubscriptionSource implements IDomainModel {
   code: SubscriptionSource_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: SubscriptionSource_): SubscriptionSource {
      return SubscriptionSources.find(d => d.code === code)
   }
}
